import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

const Back = ({ title }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "20vh", sm: "15vh", md: "20vh" },
          backgroundImage: 'url("./img/computer2.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {/* Gradient Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `linear-gradient(135deg, ${theme.palette.primary.main}cc 0%, ${theme.palette.secondary.main}99 100%)`,
            zIndex: 1,
          }}
        />

        {/* SVG Wave Overlay (15% height from bottom, 100% width) */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "5%",
            zIndex: 2,
            "& svg": {
              width: "100%",
              height: "100%",
              display: "block",
            },
          }}
        >
          <svg
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style={{ stopColor: theme.palette.background.default, stopOpacity: 0.8 }} />
                <stop offset="100%" style={{ stopColor: theme.palette.background.default, stopOpacity: 1 }} />
              </linearGradient>
            </defs>
            {/* Main wave path */}
            <path
              d="M 0,40 Q 300,10 600,40 T 1200,40 L 1200,120 L 0,120 Z"
              fill="url(#waveGradient)"
            />
            {/* Secondary decorative wave */}
            <path
              d="M 0,60 Q 300,30 600,60 T 1200,60 L 1200,120 L 0,120 Z"
              fill={theme.palette.background.default}
              opacity="0.5"
            />
          </svg>
        </Box>

        {/* Title Text */}
        <Typography
          variant="h2"
          component="h1"
          sx={{
            position: "relative",
            zIndex: 3,
            color: "#ffffff",
            fontWeight: 700,
            textAlign: "center",
            textShadow: "2px 2px 8px rgba(0, 0, 0, 0.4)",
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem", lg: "4rem" },
            px: 2,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Spacer */}
      <Box sx={{ mt: { xs: 2, sm: 2, md: 4 } }} />
    </>
  );
};

export default Back;